import { DateRange } from "@/hooks/useDateRange";
import { UserProfile } from "@/types/user-profile";
import { Booking } from "./booking";
import { Document } from "@/types/document";

export type GuestWithLastBooking = Guest & {
  lastBooking?: Booking | null;
};

type GuestProfile = {
  email: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
};
export interface Guest {
  id: string;
  profileId: string;
  guestType: GuestType;
  profile: UserProfile & GuestProfile;
  documents: Document[];
  primaryBookings: Booking[];
}

export enum GuestType {
  ADULT = "ADULT",
  CHILD = "CHILD",
}

export interface GuestPreferences {
  accommodation?: string;
  food?: string[];
  notes?: string[];
}

export enum GuestStatus {
  IN_HOUSE = "In house",
  PRE_CHECKIN = "Pre check-in",
  PRE_CHECKOUT = "Pre check-out",
  BEFORE_CHECK_IN = "Before check-in",
  BEFORE_CHECK_OUT = "Before check-out",
}

export interface GuestFilters {
  dateRange?: DateRange;
  sortField?: string | null;
  sortDirection?: "asc" | "desc" | null;
  currentPage?: number;
  perPage?: number;
  guestStatus?: GuestStatus[];
  nationality?: string[];
}

export interface CreateGuestDto {
  firstName?: string | null;
  lastName?: string | null;
  address?: string | null;
  hotelId?: string | null;
  dateOfBirth?: string | null;
  language?: string | null;
  phone?: string | null;
  email: string;
  photoId?: string | null;
  preferences?: GuestPreferences | null;
}

export type UpdateGuestDto = Partial<CreateGuestDto>;

export interface GuestsResponse {
  guests: GuestWithLastBooking[];
  total: number;
  currentPage: number;
  perPage: number;
  totalPages: number;
}

export interface GuestFilterItem {
  id: string;
  profileId: string | null;
  displayName: string;
  initials: string | null;
  email: string | null;
  phone: string | null;
}

export interface GuestFilterResponse {
  items: GuestFilterItem[];
  total: number;
  currentPage: number;
  perPage: number;
  totalPages: number;
}

export interface GuestFilterQuery {
  hotelId: string;
  name?: string;
  currentPage?: number;
  perPage?: number;
  guestStatus?: string;
  nationality?: string;
  from?: string;
  to?: string;
}
